<div class="msin-background"></div>

<mat-card appearance="outlined" class="login-page">
	<mat-card-header>
		<mat-card-title>
			<a routerLink="/login">
				<img class="login-logo" alt="MSIN Logo"
					src="../../../../../assets/images/MSIN-Logo_Color-White-Text.png" />
			</a>
		</mat-card-title>
	</mat-card-header>
	<mat-card-content>
		<mat-card appearance="outlined">
			<mat-card-header>
				<mat-card-title>Confirm Account Request</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<h3 *ngIf="isLoading" class="text-center">
					<mat-icon>
						<mat-spinner diameter="20"> </mat-spinner>
					</mat-icon>
					Confirming Email Address
				</h3>
				<h3>
					<app-msg *ngIf="!isLoading" [msg]="msg"></app-msg>
				</h3>
			</mat-card-content>
		</mat-card>
		<mat-card appearance="outlined" class="margin-top-sm">
			<a mat-raised-button routerLink="/login">Back to Login</a>
		</mat-card>
	</mat-card-content>
</mat-card>